import Cell from './src/cell';

export default Cell;



// WEBPACK FOOTER //
// ./packages/cell/index.js